export enum FilterTypeEnum {
  // card
  TYPE = "type",
  ELEMENT = "element",
  RARITY = "rarity",
  FINISH = "finish",
  SUBTYPE = "subtype",
  KEYWORD = "keyword",
  SET = "set",
  ARTIST = "artist",
  // deck
  FORMAT = "format",
  INCLUSION = "inclusion",
  EXCLUSION = "exclusion",
}

export enum ComparitorFilterTypeEnum {
  POWER = "power",
  COST = "cost",
  THRESHOLD = "threshold",
}

export enum ComparitorEnum {
  EQUALS = "=",
  LESSTHAN = "<",
  GREATERTHAN = ">",
}

export const ADVANCED_FILTER_TYPES = [
  FilterTypeEnum.SUBTYPE,
  FilterTypeEnum.KEYWORD,
  FilterTypeEnum.ARTIST,
  FilterTypeEnum.INCLUSION,
  FilterTypeEnum.EXCLUSION,
  ComparitorFilterTypeEnum.POWER,
  ComparitorFilterTypeEnum.COST,
  ComparitorFilterTypeEnum.THRESHOLD,
];

export type Option = {
  label: string;
  value: string;
  // optional spot to store more data
  data?: unknown;
  type?: "card" | "deck" | "user" | FilterTypeEnum | ComparitorFilterTypeEnum;
  // for comparitor type filters
  comparitor?: ComparitorEnum;
  // for compound comparator type filters like threshold
  target?: string | undefined;
};
